import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useFeatureTheme } from '../../../../theme/hooks/useFeatureTheme';

/**
 * Optional info tooltip beside a top field label.
 */
export default function FormFieldHint({ title }) {
  const { semantic } = useFeatureTheme();

  if (!title) {
    return null;
  }

  return (
    <Tooltip title={title} arrow placement="top">
      <IconButton
        size="small"
        tabIndex={0}
        aria-label={title}
        sx={{
          p: 0.25,
          ml: 0.25,
          color: semantic.text.muted,
          '&:hover': {
            color: semantic.text.secondary,
            backgroundColor: 'transparent',
          },
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
}
